import "../../assets/Fonts/fonts.css";
import { Sequence } from "remotion";
import { z } from "zod";
import { AudioTrack } from "./01_Audio/AudioTrack";
import { HolaSection } from "./02_Hola/Hola";
import { TuPlanSection } from "./03_Plan/TuPlan";
import { EspecificacionesSection } from "./04_Especificaciones/Especificaciones";
import { EspecificacionPantallaSection } from "./05_EspecificacionPantalla/EspecificacionPantalla";
import { EspecificacionCamaraSection } from "./06_EspecificacionCamara/EspecificacionCamara";
import { EspecificacionConectividadSection } from "./07_EspecificacionConectividad/EspecificacionConectividad";
import { EspecificacionSeguridadSection } from "./08_EspecificacionSeguridad/EspecificacionSeguridad";
import { ChatSection } from "./09_Chat/Chat";
import { ResumenSection } from "./10_Resumen/Resumen";
import { QuieroPlanSection } from "./11_Quiero/QuieroPlan";
import { GraciasSection } from "./12_Gracias/Gracias";

export const myCompSchema = z.object({
	videoFolder: z.string(),
	seccion1: z.object({
		title: z.string(),
		name: z.string(),
		text: z.string(),
	}),
	seccion2: z.object({
		cuotasText: z.string(),
		cuotasSteps: z.array(z.number()),
		cuotasPosicion: z.number(),
		title: z.string(),
		subtitle: z.string(),
		text: z.string(),
		month: z.string(),
	}),
	seccion3: z.object({
		title: z.string(),
		especificaciones: z.array(
			z.object({
				icono: z.string(),
				text: z.string(),
			}),
		),
		text: z.string(),
	}),
	seccion4: z.object({
		title: z.string(),
		text: z.string(),
	}),
	seccion5: z.object({
		title: z.string(),
		text: z.string(),
	}),
	seccion6: z.object({
		title: z.string(),
		text: z.string(),
	}),
	seccion7: z.object({
		title: z.string(),
		text: z.string(),
	}),
	seccion8: z.object({
		text1: z.string(),
		text2: z.string(),
		text3: z.string(),
		linkText: z.string(),
		linkUrl: z.string(),
	}),
	seccion9: z.object({
		plan: z.array(
			z.object({
				label: z.string(),
				value: z.string(),
			}),
		),
	}),
	seccion10: z.object({
		buttonText: z.string(),
		buttonLink: z.string(),
		title: z.string(),
		text: z.string(),
		textAlt: z.string(),
	}),
	seccion11: z.object({
		name: z.string(),
		title: z.string(),
		text: z.string(),
	}),
});

export const InitClaro: React.FC<z.infer<typeof myCompSchema>> = ({
	videoFolder,
	seccion1,
	seccion2,
	seccion3,
	seccion4,
	seccion5,
	seccion6,
	seccion7,
	seccion8,
	seccion9,
	seccion10,
	seccion11,
}) => {
	const sequences = [
		{
			component: <HolaSection {...seccion1} />,
			duration: 260,
			name: "Hola",
		},
		{
			component: <TuPlanSection {...seccion2} />,
			duration: 270,
			name: "Tu Plan",
		},
		{
			component: <EspecificacionesSection {...seccion3} />,
			duration: 430,
			name: "Especificaciones",
		},
		{
			component: <EspecificacionPantallaSection {...seccion4} />,
			duration: 125,
			name: "Esp. Pantalla",
		},
		{
			component: <EspecificacionCamaraSection {...seccion5} />,
			duration: 145,
			name: "Esp. Camara",
		},
		{
			component: <EspecificacionConectividadSection {...seccion6} />,
			duration: 80,
			name: "Esp. Conectividad",
		},
		{
			component: <EspecificacionSeguridadSection {...seccion7} />,
			duration: 80,
			name: "Esp. Seguridad",
		},
		{
			component: <ChatSection {...seccion8} />,
			duration: 405,
			name: "Chat",
		},
		{
			component: <ResumenSection {...seccion9} />,
			duration: 300,
			name: "Resumen",
		},
		{
			component: <QuieroPlanSection {...seccion10} />,
			duration: 250,
			name: "Obtener Plan",
		},
		{
			component: <GraciasSection {...seccion11} />,
			duration: 250,
			name: "Gracias",
		},
	];
	let currentStart = 0;
	return (
		<>
			<Sequence from={0} durationInFrames={2545} name="Audio: Musica">
				<AudioTrack
					videoFolder={videoFolder}
					audioName="pista_musica.mp3"
					start={0}
					end={2520}
					volume={0.1}
				/>
			</Sequence>
			<Sequence from={0} durationInFrames={2545} name="Audio: Locucion">
				<AudioTrack
					videoFolder={videoFolder}
					audioName="pista_locucion_2.mp3"
					start={0}
					end={2520}
					volume={0.5}
				/>
			</Sequence>
			{/* <Sequence from={0} durationInFrames={1166} name='Audio: 1'>
			<AudioTrack videoFolder={videoFolder} start={0} end={1166} />
		</Sequence>
		<Sequence from={1320} durationInFrames={1125} name='Audio: 2'>
			<AudioTrack videoFolder={videoFolder} start={1215} end={2362} />
		</Sequence> */}
			{sequences.map((seq, index) => {
				const from = currentStart;
				currentStart += seq.duration; // Update the start point for the next sequence

				return (
					<Sequence
						key={index}
						from={from}
						durationInFrames={seq.duration}
						name={seq.name}
					>
						{seq.component}
					</Sequence>
				);
			})}
		</>
	);
};
